import {
  FETCH_BUYER_OUTREACH,
  FETCH_BUYER_OUTREACH_SUCCESS,
  FETCH_BUYER_OUTREACH_FAIL,
  UPDATE_BUYER_OUTREACH,
  UPDATE_BUYER_OUTREACH_SUCCESS,
  UPDATE_BUYER_OUTREACH_FAIL
} from '../actions/types'

const INITIAL_STATE = {
  bySeller: {}
}

const set = (map, key, patch) => ({
  ...map,
  [key]: { ...(map[key] || {}), ...patch }
})

const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object || {}, key)

const STATUS_KEYS = ['linkedin_outreach_status', 'email_outreach_status']

const patchBuyerOutreachRow = (row, patch = {}) => {
  const nextValues = patch.values ? { ...(row.values || {}), ...patch.values } : row.values
  const nextRow = {
    ...row,
    ...(hasOwn(patch, 'metadata') ? { metadata: patch.metadata } : {}),
    ...(hasOwn(patch, 'style') ? { style: patch.style } : {}),
    ...(patch.cell_styles ? { cell_styles_by_key: { ...(row.cell_styles_by_key || {}), ...patch.cell_styles } } : {}),
    ...(nextValues ? { values: nextValues } : {})
  }

  STATUS_KEYS.forEach((statusKey) => {
    if (hasOwn(patch, statusKey)) {
      nextRow[statusKey] = patch[statusKey]
    }
    if (hasOwn(patch.values, statusKey)) {
      nextRow[statusKey] = patch.values[statusKey] || 'not_started'
    }
  })

  return nextRow
}

const patchBuyerOutreachSheetRow = (sheet, rowId, patch) => {
  if (!sheet?.rows || !rowId || !patch) return sheet
  return {
    ...sheet,
    rows: sheet.rows.map((row) => (
      row.id === rowId ? patchBuyerOutreachRow(row, patch) : row
    ))
  }
}

const deleteBuyerOutreachSheetRow = (sheet, rowId) => {
  if (!sheet?.rows || !rowId) return sheet
  return {
    ...sheet,
    rows: sheet.rows.filter((row) => row.id !== rowId)
  }
}

export default function buyerOutreachReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_BUYER_OUTREACH:
      return { ...state, bySeller: set(state.bySeller, action.payload.sellerId, { loading: true, error: null }) }
    case FETCH_BUYER_OUTREACH_SUCCESS:
      return {
        ...state,
        bySeller: set(state.bySeller, action.payload.sellerId, {
          data: action.payload.data,
          loading: false,
          saving: false,
          error: null,
          fetchedAt: Date.now()
        })
      }
    case FETCH_BUYER_OUTREACH_FAIL:
      return { ...state, bySeller: set(state.bySeller, action.payload.sellerId, { loading: false, error: action.payload.error }) }
    case UPDATE_BUYER_OUTREACH: {
      const currentEntry = state.bySeller[action.payload.sellerId]
      const deleteRowIds = action.payload.deleteRowIds
        || (action.payload.deleteRowId ? [action.payload.deleteRowId] : null)
      const optimisticData = deleteRowIds
        ? deleteRowIds.reduce((data, rowId) => deleteBuyerOutreachSheetRow(data, rowId) || data, currentEntry?.data)
        : patchBuyerOutreachSheetRow(currentEntry?.data, action.payload.rowId, action.payload.data)
      return {
        ...state,
        bySeller: set(state.bySeller, action.payload.sellerId, {
          ...(optimisticData ? { data: optimisticData } : {}),
          saving: true,
          error: null
        })
      }
    }
    case UPDATE_BUYER_OUTREACH_SUCCESS:
      return {
        ...state,
        bySeller: set(state.bySeller, action.payload.sellerId, {
          data: action.payload.data,
          saving: false,
          error: null,
          fetchedAt: Date.now()
        })
      }
    case UPDATE_BUYER_OUTREACH_FAIL:
      return { ...state, bySeller: set(state.bySeller, action.payload.sellerId, { saving: false, error: action.payload.error }) }
    default:
      return state
  }
}
